<template>
  <div id="app">
    <!-- 路由的出口 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.loadData()
  },
  methods: {
    isMobile() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    },
    initData() {
      // 如果不是我们则认为是pc端
      if (!this.isMobile() && window.innerWidth > 540) {
        const html = document.querySelector('html')
        const body = document.querySelector('body')

        html.style.margin = '0 auto'
        // 固定宽度
        html.style.maxWidth = '540px'
        // body.style.maxWidth = '440px'

        html.style.fontSize = '54px'

        // 加个阴影点缀一下。
        // body.style.boxShadow = '0 0 20px rgba(0, 0, 0, .5)'
        // 最后重点：pc端fixed定位,修正为body, 而不是视口
        body.style.transform = 'translate(0)'
        //缓存记录是PC端
        localStorage.setItem('isPC', 'true')
      } else {
        const html = document.querySelector('html')
        const body = document.querySelector('body')
        html.style.maxWidth = '100vw'
        body.style.maxWidth = '100vw'
        html.style.fontSize = 'auto'
        
        //缓存记录不是PC端
        localStorage.setItem('isPC', 'false')
      }
    },
    loadData() {
      this.initData()
      window.addEventListener('resize', () => {
        this.initData()
      })
    }
  }
}
</script>

<style lang="less"> 

</style>
